import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import BootstrapSpinner from 'react-bootstrap/Spinner';
import './spinner.scss';

const Spinner = ({
  isLoading = false,
  isAbsolute = false,
  elementType = 'div',
  animation = 'border',
  colorVariant = 'primary',
  spinnerContainerClass,
  size,
  className,
  children,
}) => {
  return (
    <div
      data-testid='spinner-container'
      className={classNames(spinnerContainerClass, {
        'd-none': !isLoading,
        'spinner-absolute-container': isAbsolute,
      })}
    >
      <BootstrapSpinner
        data-testid='spinner'
        as={elementType}
        animation={animation}
        size={size}
        variant={colorVariant}
        className={className}
      >
        {children}
      </BootstrapSpinner>
    </div>
  );
};

Spinner.propTypes = {
  spinnerContainerClass: PropTypes.string,
  isLoading: PropTypes.bool,
  isAbsolute: PropTypes.bool,
  elementType: PropTypes.string,
  animation: PropTypes.string,
  size: PropTypes.string,
  colorVariant: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.func,
};

export default Spinner;
